require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/es7.symbol.observable.js
// module id = 1050
// module chunks = 48 49 50